// extracted by extract-css-chunks-webpack-plugin
module.exports = {"logo":"logo-29egKx6A","breadcrumbs":"breadcrumbs-haspRKL1"};